module.exports = __webpack_public_path__ + "img/transaction-sidebar-act.89a279d8.svg";